/* confluenceStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./confluenceStyleWrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIsConfluenceModule } from '../utils/useIsConfluenceModule';

// This overrides Confluence webpack styling that affects chart components in confluence modules
var chartStyle = null;
export var withConfluenceStyleWrapper = function withConfluenceStyleWrapper(ChartComponent) {
  return function ConfluenceStyleWrapper(props) {
    var isConfluenceModule = useIsConfluenceModule();
    return isConfluenceModule ? /*#__PURE__*/React.createElement("div", {
      className: ax(["_1hur1o8v _15ywze3t _xlx2ze3t _ohs2131l _v8kv1o8v _1t4h131l _12r8nbxd _tc2g1gjq _1prk2smr _1x821gjq _59ea1vhk _9y82ze3t _7ve0ze3t _zi1a131l _125ipxbi"])
    }, /*#__PURE__*/React.createElement(ChartComponent, props)) : /*#__PURE__*/React.createElement(ChartComponent, props);
  };
};